module.exports = __webpack_public_path__ + "static/13-619cf7cf5793c6f4d59c5c031bc27a39.png";